<template>
    <div class="content-wrapper">
        <PageHeader screenName="Ver Unidades" :linkItems="linkItems" />

        <main class="card">
            <!-- botão para adicionar nova unidade -->
            <div class="pt-2 px-2" v-if="podeCadastrarUnidade">
                <b-button @click="redirectToRegisterUnidade()" variant="primary-button">
                    <feather-icon icon="PlusIcon" class="mr-50" />
                    <span class="align-middle">Adicionar nova unidade</span>
                </b-button>
            </div>

            <!-- botão filtros -->
            <ListagemFiltros @filtrarUnidade="(param) => handleFormFiltros('formData', param)" :listagem="true"/>

            <!-- qtd mostrar -->
            <b-row align-h="between" class="px-2">
              <b-col lg="9" md="9" sm="12">
                  <TableFilter :filter="filter" @filterTable="(param) => handleFormFiltros('paginationData', param)"
                             :showInputFilter="false" />
              </b-col>
              <b-col lg="3" md="3" sm="12" class="d-flex align-items-center justify-content-end mb-1">
                <ButtonDownloadSpreadsheet
                    type="Unidade"
                    :parameters="getParams"
                    :size="paginationData.totalLines"
                    :isEmpty="paginationData.totalLines === 0"
                    tooltip-text="Exportar unidades operacionais" />
              </b-col>
            </b-row>

            <ListagemTabela :parametros="getParams" :key="indiceListagemTabela"
                @updatePagination="(param) => handleFormFiltros('paginationData', param)"
                @sortTable="(param) => handleFormFiltros('tableData', param)" />

        </main>
    </div>
</template>

<script>
import { actions, subjects } from "@/libs/acl/rules";
import {BButton, BCol, BRow} from 'bootstrap-vue';
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import TableFilter from '@/views/components/custom/table-filter-section/TableFilter.vue';
import ListagemFiltros from "./parts/ListagemFiltros.vue";
import ListagemTabela from "./parts/ListagemTabela.vue";
import ButtonDownloadSpreadsheet from "@/views/components/button-download-spreadsheet/ButtonDownloadSpreadsheet.vue";

export default {
    title: 'Unidades',

    components: {
      BRow,
      ButtonDownloadSpreadsheet,
      BCol,
        PageHeader,
        ListagemFiltros,
        ListagemTabela,
        BButton,
        TableFilter,
    },

    data() {
        return {
            linkItems: [
                { name: 'Unidades Operacionais', active: true }
            ],
            indiceListagemTabela: 0,
            filter: false,
            paginationData: {
                currentPage: 1,
                defaultSize: 10,
                fromLine: 0,
                toLine: 0,
                totalLines: 0,
                searchTerm: "",
                route: "unidade-list",
            },
            formData: {
                departamentoRegional: null,
                nomeUnidadeOperacional: null,
                tipo: null,
            },
            tableData: {
                columnOrder: 'descricao_unidade',
                order: 'asc'
            },
        }
    },

    methods: {
        redirectToRegisterUnidade() {
            this.$router.push({ name: 'unidade-register' });
        },
        isDifferent(a, b) {
            return Object.keys(b).some(key => b[key] !== a[key]);
        },
        handleFormFiltros(tipo, dados) {
            const temValoresDirefentes = this.isDifferent(this[tipo], dados);
            this[tipo] = { ...dados }
            if (tipo == 'formData') {
                this.paginationData.currentPage = 1
            }

            this.indiceListagemTabela = temValoresDirefentes ? this.indiceListagemTabela + 1 : this.indiceListagemTabela;
            this.loadParamsUnidade();
        },

        loadParamsUnidade() {
          const params = this.getParams;
          this.$http.get(this.$api.unidade(), { params: params }).then(({ data }) => {
            this.$set(this.paginationData, 'currentPage', data.current_page);
            this.$set(this.paginationData, 'totalLines', data.total);
            this.$set(this.paginationData, 'fromLine', data.from);
            this.$set(this.paginationData, 'toLine', data.to);
            this.$set(this.paginationData, 'defaultSize', data.per_page);
          })
        },
    },

    mounted() {
      this.loadParamsUnidade();
    },

    computed: {
        podeCadastrarUnidade() {
            return this.$can(actions.INSERIR, subjects.UNIDADE_PROPRIA)
                || this.$can(actions.INSERIR, subjects.UNIDADE_TERCEIRA);
        },
        getParams() {
            return {
                termoPesquisa: this.formData.nomeUnidadeOperacional ?? '',
                tamanho: this.paginationData.defaultSize,
                pagina: this.paginationData.currentPage,
                colunaOrdenar: this.tableData.columnOrder,
                ordem: this.tableData.order,
                id_departamento: this.formData.departamentoRegional?.id_departamento ?? null,
                tipo_unidade: this.formData.tipo ?? null
            }
        },
    }

}
</script>
